import React from 'react'

export const TopMenuLinkSeparator = (props) => {
    return <span className='topMenuLinkSeparator'>|</span>
}

